import GridItem from 'Atoms/Grids/GridItem';
import { EmailIcon, SupportIcon } from 'Atoms/Icons';
import { H3 } from 'Atoms/Typography/Headings/Heading';
import SmallLabel from 'Atoms/Typography/SmallLabel/SmallLabel';
import EmailBlockModel from 'Models/Blocks/EmailBlock/EmailBlockModel.interface';
import MapsBlockModel from 'Models/Blocks/MapsBlock/MapsBlockModel.interface';

import { styled } from 'stitches.config';

type PropType = {
  content: MapsBlockModel;
};

const MAPS_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2244.5180482416263!2d12.998077315931093!3d55.76687398055717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4653ba336243828d%3A0xec4a959eb41b73a4!2sJE68%20Motorcycles%20AB%20%2F%20Jonte%20Engdahl%20Motorsport%20AB!5e0!3m2!1sen!2sse!4v1658844820729!5m2!1sen!2sse';

const GoogleMaps = () => {
  return (
    <iframe
      title="google maps"
      src={MAPS_URL}
      height="480"
      style={{ border: 0, filter: 'invert(90%)', width: '100%' }}
      allowFullScreen={true}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
};

const MapsBlock = ({
  content: { phone, emails, addressBodyText, header },
}: PropType) => {
  return (
    <GridItem>
      <ContactContainer>
        <Phone href={`tel:${phone}`}>
          <SupportIcon color="primary" size="m" />
          <H3 noMargin>{phone}</H3>
        </Phone>
        <Emails>
          {emails.map((e: EmailBlockModel, i: number) => (
            <div key={e.email + i}>
              <SmallLabel>{e.heading}</SmallLabel>
              <Link href={`mailto:${e.email}`}>
                <EmailIcon color="primary" size="m" />
                {e.email}
              </Link>
            </div>
          ))}
        </Emails>
      </ContactContainer>

      <LocationContainer>
        <GoogleMaps />
        <OpeningHours>
          <H3>{header}</H3>
          <AddressBodyText
            dangerouslySetInnerHTML={{
              __html: addressBodyText,
            }}
          />
        </OpeningHours>
      </LocationContainer>
    </GridItem>
  );
};

const AddressBodyText = styled('div', {
  'ol, ul': {
    listStyle: 'initial',
    my: 4,
    pl: 10,
  },
});

const ContactContainer = styled('div', {
  backgroundColor: '$primary4',
  width: '100%',
  px: 6,
  py: 8,
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: 32,
  mb: 8,
  mt: 16,
  '@mediaMinLarge': { p: 12, mb: 12 },
});

const Phone = styled('a', {
  display: 'flex',
  width: '100%',
  gap: 16,
  flexGrow: 1,
});

const Link = styled('a', {
  display: 'flex',
  width: '100%',
  gap: 8,
  alignItems: 'center',
});

const Emails = styled('div', {
  display: 'flex',
  width: '100%',
  columnGap: 96,
  rowGap: 32,
  flexWrap: 'wrap',
});

const LocationContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  mb: 20,
  '@mediaMinLarge': { flexDirection: 'row', mb: 26 },
});

const OpeningHours = styled('div', {
  backgroundColor: '$primary4',
  width: '100%',
  px: 4,
  py: 8,
  fs: 8,
  lineHeight: '$lh15',
  '@mediaMinLarge': { p: 12 },
});

export default MapsBlock;
